import {Component, OnInit} from '@angular/core';
import {loginItem, loginItemList} from '../../../_animations/loginAnimations';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MustMatch} from '../../../_helpers/validators/mustMatch';
import {Digits} from '../../../_helpers/validators/digits';
import {first} from 'rxjs/operators';
import {AuthService} from '../../../_services/auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-reset-password-confirm',
  templateUrl: './reset-password-confirm.component.html',
  styleUrls: ['./reset-password-confirm.component.scss', '../../../../loginForm.scss'],
  animations: [loginItemList, loginItem]
})
export class ResetPasswordConfirmComponent implements OnInit {
  loading: boolean;
  params: any;
  form: FormGroup;

  constructor(private formBuilder: FormBuilder, private auth: AuthService, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.loading = true;
    this.activatedRoute.params.subscribe(params => {
      this.loading = true;
      this.params = params;
      const resetPasswordDataConfirm = {
        uidb: this.params.uidb,
        token: this.params.token
      };

      this.auth
        .resetPasswordConfirmStatus(resetPasswordDataConfirm)
        .pipe(first())
        .subscribe(
          response => {
            if (response.status === 'success') {
              this.loading = false;
            } else if (response.status === 'error') {
              this.router.navigate(['/login'], {
                state: {mode: 'inactive_link'}
              });
            }
          },
          error => {
            this.loading = false;
          }
        );


    });
    this.form = this.formBuilder.group(
      {
        password: ['', [
          Validators.required,
          Validators.minLength(8),
          Digits.digits
        ]],
        confirmPass: new FormControl('', [Validators.required])
      },
      {
        validator: MustMatch('password', 'confirmPass')
      }
    );
  }

  createNewPassword() {
    this.loading = true;
    const resetPasswordData = {
      password1: this.form.value.password,
      password2: this.form.value.confirmPass,
      uidb: this.params.uidb,
      token: this.params.token
    };

    this.auth
      .resetPasswordConfirm(resetPasswordData)
      .pipe(first())
      .subscribe(
        response => {
          this.loading = false;
          if (response.status === 'success') {
            localStorage.setItem('currentUser', JSON.stringify(response.token));
            this.router.navigate(['/']);
          } else if (response.status === 'error') {
            this.router.navigate(['/login'], {
              state: { mode: 'inactive_link' }
            });
          }
        },
        error => {
          this.loading = false;
        }
      );
  }

}
